import React, { Children } from 'react';
import Grid from '@mui/material/Grid2';
import PropTypes from 'prop-types';

export default function AuditionAdditionalDetailsGrid({ children }) {
  const items = Children.toArray(children);

  return (
    (<Grid container spacing={0}>
      <Grid size={12}>{items[0]}</Grid>
      <Grid size={12}>{items[1]}</Grid>
    </Grid>)
  );
}

AuditionAdditionalDetailsGrid.propTypes = {
  children: PropTypes.node,
};
